import React, { ReactNode } from "react";

import styles from "./BaseOptionsItem.module.scss";

interface Props {
  children: ReactNode; // whatever value editor
  label: ReactNode;
}

const BaseOptionItem: React.FC<Props> = ({ children, label }) => {
  return (
    <div className={styles.container}>
      <div className={styles.editor}>{children}</div>
      <div className={styles.label}>{label}</div>
    </div>
  );
};

export default BaseOptionItem;
